<template>
    <div class="calculadora calculadora-cardiovascular">
        <div class="steps-list">
              <div @click="vaParaPasso(i)"
                   :class="{step: true, active: i === passo_atual, done: i < +passo_atual}"
                   v-for="(step, i) in steps">
                  <span class="step-ico" :class="['step-ico-' + step]">
                      <svg class="icon">
                          <use :xlink:href="step"></use>
                      </svg>
                  </span>

                  <span class="step-title">{{ strings.step }} {{ i + 1 }} <div class="total">/{{ passo_max + 1 }}</div></span>
              </div>
        </div>

        <div class="step-content" v-if="estaNoPasso(0)">
            <div>
                <label class="step-title">{{ strings.fields.gender.label }}:</label>

                <div class="horizontal-inputs">
                    <label for="rdb-genero-man" class="eurofarma-radio-input" :class="{selected: inputs.genero === 'masculino'}">
                        <input type="radio" value="masculino" id="rdb-genero-man" name="genero"
                               v-model="inputs.genero"
                               :required="estaNoPasso(0)"/>
                        <span>{{ strings.fields.gender.option1 }}</span>
                    </label>
                    <label for="rdb-genero-fem" class="eurofarma-radio-input" :class="{selected: inputs.genero === 'feminino'}">
                        <input type="radio" value="feminino" id="rdb-genero-fem" name="genero"
                               v-model="inputs.genero"
                               :required="estaNoPasso(0)"/>
                        <span>{{ strings.fields.gender.option2 }}</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="step-content col-sm-12" v-if="estaNoPasso(1)">
            <div class="row">
                <div class="form-group">
                  <label class="step-title" for="num-idade">{{ strings.fields.age.label }}:</label>
                  <div>
                    <input :placeholder="strings.fields.age.placeholder" class="form-control" type="number" name="idade" id="num-idade" v-model="inputs.idade"
                           :required="estaNoPasso(1)"/>
                  </div>
                </div>
            </div>
        </div>

        <div class="step-content col-sm-12" v-if="estaNoPasso(2)">
            <div>
                <label class="step-title">{{ strings.fields.cholesterol.label }}:</label>

                <div class="row">
                    <div class="col-sm-12 col-md-6 form-group">
                        <input :placeholder="strings.fields.cholesterol.placeholder1" type="text" id="txt-ldl" name="ldl" class="form-control" v-model="inputs.ldl"
                               :required="estaNoPasso(2)"/>
                        <label for="txt-ldl">LDL (mg/dl)</label>
                    </div>
                    <div class="col-sm-12 col-md-6 form-group">
                        <input :placeholder="strings.fields.cholesterol.placeholder2" type="text" id="txt-hdl" name="hdl"  class="form-control" v-model="inputs.hdl"
                               :required="estaNoPasso(2)"/>
                        <label for="txt-hdl">HDL (mg/dl)</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="step-content col-sm-12" v-if="estaNoPasso(3)">
            <div>
                <label class="step-title">{{ strings.fields.arterial_pressure.label }}:</label>
                <div class="row ">
                    <div class="col-sm-12 col-md-6 form-group">
                        <input :placeholder="strings.fields.arterial_pressure.placeholder1" type="text" id="txt-sistolica" name="sistolica" class="form-control" v-model="inputs.sistolica"
                               :required="estaNoPasso(3)"/>
                        <label>{{ strings.fields.arterial_pressure.desc1 }} (mm/Hg)</label>
                    </div>

                    <div class="col-sm-12 col-md-6 form-group">
                        <input :placeholder="strings.fields.arterial_pressure.placeholder2" type="text" id="txt-diastolica" name="diastolica" class="form-control" v-model="inputs.diastolica"
                               :required="estaNoPasso(3)"/>
                        <label>{{ strings.fields.arterial_pressure.desc2 }} (mm/Hg)</label>
                    </div>
                </div>
                <div>
                    <small>{{ strings.fields.arterial_pressure.specs }}</small>
                </div>
            </div>
        </div>

        <div class="step-content col-sm-12" v-if="estaNoPasso(4)">
            <div>
                <label class="step-title">{{ strings.fields.physical_activity.title }}</label>
                <div class="row horizontal-inputs">
                    <label class="col-sm-12" :class="{selected: inputs.atividade === true}">
                        <input type="radio" id="rdb-atividade-sim" v-model="inputs.atividade" name="atividade"
                               :required="estaNoPasso(4)" :value="true"/>
                        <span>{{ strings.yes }}</span>
                    </label>
                    <label class="col-sm-12" :class="{selected: inputs.atividade === false}">
                        <input type="radio" id="rdb-atividade-nao" v-model="inputs.atividade" name="atividade"
                               :required="estaNoPasso(4)" :value="false"/>
                        <span>{{ strings.no }}</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="step-content col-sm-12" v-if="estaNoPasso(5)">
            <div>
              <label class="step-title">{{ strings.fields.diabetes.title }}</label>
                <div class="row horizontal-inputs">
                    <label class="col-sm-12" :class="{selected: inputs.diabetes === true}">
                        <input type="radio" id="rdb-diabetes-sim" name="diabetes" v-model="inputs.diabetes"
                               :required="estaNoPasso(5)" :value="true"/>
                        <span>{{ strings.yes }}</span>
                    </label>
                    <label class="col-sm-12" :class="{selected: inputs.diabetes === false}">
                        <input type="radio" id="rdb-diabetes-nao" name="diabetes" v-model="inputs.diabetes"
                               :required="estaNoPasso(5)" :value="false"/>
                        <span>{{ strings.no }}</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="step-content col-sm-12" v-if="estaNoPasso(6)">
            <div>
              <label class="step-title">{{ strings.fields.obese.title }}</label>
                <div class="row horizontal-inputs">
                    <label class="col-sm-12" :class="{selected: inputs.obesidade === true}">
                        <input type="radio" id="rdb-obesidade-sim" name="obesidade" v-model="inputs.obesidade"
                               :required="estaNoPasso(6)" :value="true"/>
                        <span>{{ strings.yes }}</span>
                    </label>
                    <label class="col-sm-12" :class="{selected: inputs.obesidade === false}">
                        <input type="radio" id="rdb-obesidade-nao" name="obesidade" v-model="inputs.obesidade"
                               :required="estaNoPasso(6)" :value="false"/>
                        <span>{{ strings.no }}</span>
                    </label>
                </div>
                <small>IMC > 30 kg/m²</small>
            </div>
        </div>


        <div class="step-content col-sm-12" v-if="estaNoPasso(7)">
            <div>
                <label class="step-title">{{ strings.fields.smoker.title }}</label>
                <div class="row horizontal-inputs">
                    <label class="col-sm-12" :class="{selected: inputs.cigarro === true}">
                        <input type="radio" id="rdb-cigarro-sim" v-model="inputs.cigarro" name="cigarro"
                               :required="estaNoPasso(7)" :value="true"/>
                        <span>{{ strings.yes }}</span>
                    </label>
                    <label class="col-sm-12" :class="{selected: inputs.cigarro === false}">
                        <input type="radio" id="rdb-cigarro-nao" v-model="inputs.cigarro" name="cigarro"
                               :required="estaNoPasso(7)" :value="false"/>
                        <span>{{ strings.no }}</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="step-content col-sm-12" v-if="estaNoPasso(8) && !calculado">
            <div>
                <label class="step-title">{{ strings.fields.history.title }}</label>
                <label class="step-title"></label>
                <div class="row align-items-center">

                  <div class="col-sm-12 col-md-4" v-for="(item,label) in strings.fields.history.list">
                    <div class="history-items">
                        <label class="custom-eurofarma-checkbox" :for="'ckb-factor-' + label" :class="{ selected: inputs[label] === true }">
                          <input type="checkbox" :id="'ckb-factor-' + label" v-model="inputs[label]" name="historico" :value="true"/> <span>{{ item }}</span>
                        </label>
                    </div>
                  </div>

                </div>
                <small>{{ strings.results.label}}</small>
            </div>
        </div>

        <div class="row">
            <div class="step-content result-content col-sm-12" v-if="calculado">
                <div>
                    <h3 v-html="strings.results.info + ' ' + textoChance + ' ' + strings.results.info_pt2"></h3>
                </div>
                <p class="d-block" v-html="strings.results.desc + ' ' +  chance + strings.results.desc_pt2">

                </p>
            </div>

            <div class="col-sm-12 buttons-area">
                <div class="cta-area">
                    <a href="#" @click.prevent="passoAnterior()" v-if="!primeiroPasso && !calculado"
                       class="btn btn-primary">
                        {{ strings.buttons.prev }}
                    </a>

                    <a href="#" @click.prevent="calc()" v-if="ultimoPasso && !calculado" class="btn btn-primary btn-calc">
                        {{ strings.buttons.calc }}
                    </a>

                    <a href="#" @click.prevent="reset()" v-if="calculado" class="btn btn-primary">
                        {{ strings.buttons.new_calc }}
                    </a>
                    <a href="#" @click.prevent="passoPosterior()" v-if="!ultimoPasso" class="btn btn-primary">
                        {{ strings.buttons.next }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import './resources/sass/frontend/variables';
    // Imported from bitbucket.org/eurofarma/calculadora-cardiovascular

</style>
<script>
    // Ported from AngularJS application / at bitbucket.org/eurofarma/calculadora-cardiovascular

    export default {

        props: {
            strings: Object
        },

        data: () => {
            return {
                primeiroPasso: true,
                ultimoPasso: false,
                calculado: false,

                passo_atual: 0,
                passo_max: 8,
                chance: null,
                score: 0,

                steps: [
                    '/images/cardiovascular/sprite.svg#sexos',
                    '/images/cardiovascular/sprite.svg#relogio',
                    '/images/cardiovascular/sprite.svg#pilulas',
                    '/images/cardiovascular/sprite.svg#coracao',
                    '/images/cardiovascular/sprite.svg#batimento',
                    '/images/cardiovascular/sprite.svg#bala',
                    '/images/cardiovascular/sprite.svg#pizza',
                    '/images/cardiovascular/sprite.svg#cigarro',
                    '/images/cardiovascular/sprite.svg#homem'
                ],

                inputs: {
                    genero: null,
                    idade: null,
                    ldl: null,
                    hdl: null,
                    sistolica: null,
                    diastolica: null,
                    atividade: null,
                    obesidade: null,
                    diabetes: null,
                    cigarro: null,
                    historico: null,
                    eventoPrevio: null,
                    avc: null,
                    ait: null,
                    iam: null,
                    hve: null, //hipertrofia ventricular esquerda
                    renal: null,
                    periferica: null
                },

                // Hipertensão - com base na pressão sistólica/diastólica
                fatoresDeRisco: {
                    baixoIntermediario: [],
                    alto: []
                },
            }
        },

        mounted: function () {

        },

        methods: {
            reset: function () {

                this.passo_atual = 0;
                this.primeiroPasso = true;
                this.ultimoPasso = false;

                for (let [key, value] of Object.entries(this.inputs)) {
                    this.inputs[key] = null;
                }

                this.calculado = false;
            },

            estaNoPasso: function (step) {
                return step === this.passo_atual;
            },

            passoPosterior: function () {
                if (!this.validarPasso()) return;
                this.passo_atual++;

                this.primeiroPasso = false;
                this.ultimoPasso = this.passo_atual === this.passo_max;
            },

            passoAnterior: function () {
                this.passo_atual--;

                this.ultimoPasso = false;
                this.primeiroPasso = this.passo_atual === 0;
            },

            vaParaPasso: function (step) {
                if (step >= this.passo_atual || this.calculado)
                    return;
                this.passo_atual = step;
                this.primeiroPasso = this.passo_atual === 0;
            },

            calc: function () {
                if (!this.validarPasso()) return;

                console.log("validando campos...");
                let error = null;

                if (this.inputs.genero === null) error = "o campo genero não foi preenchido";
                if (this.inputs.idade === null) error = "o campo idade não foi preenchido";
                if (this.inputs.ldl === null) error = "o campo ldl não foi preenchido";
                if (this.inputs.hdl === null) error = "o campo hdl não foi preenchido";
                if (this.inputs.sistolica === null) error = "o campo sistolica não foi preenchido";
                if (this.inputs.diastolica === null) error = "o campo diastolica não foi preenchido";
                if (this.inputs.diabetes === null) error = "o campo diabetes não foi preenchido";
                if (this.inputs.atividade === null) error = "o campo atividade não foi preenchido";
                if (this.inputs.cigarro === null) error = "o campo cigarro não foi preenchido";

                if (error) {
                    console.log("foi encontrado um erro:", error);
                    return alert(error);
                }

                console.log("Iniciando calculos...");

                console.log("calculando idade...");
                this.CalcRiscoIdade();

                console.log("calculando risco IDL...");
                this.CalcRiscoIdl();

                console.log("calculando risco HDL...");
                this.CalcRiscoHdl();

                console.log("calculando risco Pressao...");
                this.CalcRiscoPressao();

                console.log("calculando risco diabetes...");
                this.CalcRiscoDiabetes();

                console.log("calculando risco cigarro");
                this.CalcRiscoCigarro();

                this.showResult();
                console.log("exibindo score:", this.score);

                console.log("verificando fatores de risco...");
                if (this.CalcFatoresDeRisco()) {
                    return;
                }

                this.textoChance = this.chance < 10 ? 'BAIXO' : (this.chance <= 20 ? 'MÉDIO' : 'ALTO');
                if (this.inputs.genero === "masculino" && this.chance >= 56 ||
                        this.inputs.genero === "feminino" && this.chance >= 32)
                    this.chance = ">=" + this.chance;

                this.calculado = true;
            },

            validarPasso: function () {

                switch (this.passo_atual) {
                    case 0:
                        if (!this.inputs.genero) return alert("Selecione uma opção.");

                        return true;

                    case 1:
                        if (!this.inputs.idade) return alert("Informe uma idade válida.");

                        return true;

                    case 2:
                        if (!this.inputs.ldl) return alert("Valor ldl inválido.");
                        if (!this.inputs.hdl) return alert("Valor hdl inválido.");

                        return true;

                    case 3:
                        if (!this.inputs.sistolica) return alert("Valor de pressão sistólica inválido.");
                        if (!this.inputs.diastolica) return alert("Valor de pressão diastólica inválido.");

                        return true;

                    case 4:
                        if (this.inputs.atividade === null) return alert("Selecione uma opção.");

                        return true;

                    case 5:
                        if (this.inputs.diabetes === null) return alert("Selecione uma opção.");

                        return true;

                    case 6:
                        if (this.inputs.obesidade === null) return alert("Selecione uma opção.");

                        return true;

                    case 7:
                        if (this.inputs.cigarro === null) return alert("Selecione uma opção.");

                        return true;
                }

                return true;
            },

            CalcFatoresDeRisco: function () {
                //Retorna verdadeiro caso apresente apenas um fator de risco baixo ou intermediário, barrando o cálculo posterior
                //por não haver a necessidade de calcular os fatores de risco;
                this.inputs.cigarro ? this.fatoresDeRisco.baixoIntermediario.push("Tabagismo") : '';
                this.inputs.sistolica > 140 && this.inputs.diastolica > 90 ? this.fatoresDeRisco.baixoIntermediario.push("Hipertensão") : '';
                //Obesidade
                !this.inputs.atividade ? this.fatoresDeRisco.baixoIntermediario.push("Sedentarismo") : '';
                this.inputs.genero === "masculino" ? this.fatoresDeRisco.baixoIntermediario.push("Sexo Masculino") : '';
                this.inputs.idade > 65 ? this.fatoresDeRisco.baixoIntermediario.push("idade > 65") : '';
                //Histórico Familiar
                //Evento cardiovascular prévio
                (this.inputs.genero === "masculino" && this.inputs.idade < 55 || this.inputs.genero === "feminino" && this.inputs.idade < 65)
                && this.inputs.eventoPrevio ? this.fatoresDeRisco.baixoIntermediario.push("Evento prévio") : '';

                this.inputs.avc ? this.fatoresDeRisco.alto.push("AVC (acidente vascular cerebral) previamente") : '';
                this.inputs.iam ? this.fatoresDeRisco.alto.push("IAM (infarto agudo do miocárdio) previamente") : '';
                this.inputs.ait ? this.fatoresDeRisco.alto.push("AIT (ataque isquêmico transitório)") : '';
                this.inputs.hve ? this.fatoresDeRisco.alto.push("HVE (hipertrofia de ventrículo esquerdo)") : '';
                this.inputs.renal ? this.fatoresDeRisco.alto.push("Doença renal crônica") : '';
                this.inputs.periferica ? this.fatoresDeRisco.alto.push("Doença vascular periférica") : '';
                this.inputs.diabetes ? this.fatoresDeRisco.alto.push("Diabetes") : '';

                console.log(this.fatoresDeRisco);

                if (this.fatoresDeRisco.baixoIntermediario.length <= 1 && this.fatoresDeRisco.alto <= 0) {
                    this.chance = "<=10";
                    this.textoChance = 'BAIXO';
                    return true;
                } else if (this.fatoresDeRisco.alto > 1) {
                    this.textoChance = 'ALTO';
                    this.chance < 20 ? this.chance = "<=20" : this.chance = "<=" + this.chance;
                    return true;
                }
            },

            CalcRiscoIdade: function () {

                const idade = this.inputs.idade;
                //Idades abaixo de 30 e acima de 74 assumem os valores mais próximos da tabela

                if (this.inputs.genero === "masculino") {
                    if (idade < 35) {
                        this.score += -1;
                    } else if (idade >= 35 && idade < 40) {
                        this.score += 0;
                    } else if (idade >= 40 && idade < 45) {
                        this.score += 1;
                    } else if (idade >= 45 && idade < 50) {
                        this.score += 2;
                    } else if (idade >= 50 && idade < 55) {
                        this.score += 3;
                    } else if (idade >= 55 && idade < 60) {
                        this.score += 4;
                    } else if (idade >= 60 && idade < 65) {
                        this.score += 5;
                    } else if (idade >= 65 && idade < 70) {
                        this.score += 6;
                    } else if (idade >= 70) {
                        this.score += 7;
                    }

                } else if (this.inputs.genero === 'feminino') {
                    if (idade < 35) {
                        this.score += -9;
                    } else if (idade >= 35 && idade < 40) {
                        this.score += -4;
                    } else if (idade >= 40 && idade < 45) {
                        this.score += 0;
                    } else if (idade >= 45 && idade < 50) {
                        this.score += 3;
                    } else if (idade >= 50 && idade < 55) {
                        this.score += 6;
                    } else if (idade >= 55 && idade < 60) {
                        this.score += 7;
                    } else if (idade >= 60 && idade < 65) {
                        this.score += 8;
                    } else if (idade >= 65 && idade < 70) {
                        this.score += 8;
                    } else if (idade >= 70) {
                        this.score += 8;
                    }
                }
            },

            CalcRiscoIdl: function () {

                const ldl = this.ldl;

                if (this.inputs.genero === "masculino") {
                    if (ldl < 100) {
                        this.score += -3;
                    } else if (ldl >= 100 && ldl < 130) {
                        this.score += 0;
                    } else if (ldl >= 130 && ldl < 160) {
                        this.score += 0;
                    } else if (ldl >= 160 && ldl < 190) {
                        this.score += 1;
                    } else if (ldl >= 190) {
                        this.score += 2;
                    }
                } else if (this.inputs.genero === "feminino") {
                    if (ldl < 100) {
                        this.score += -2;
                    } else if (ldl >= 100 && ldl < 130) {
                        this.score += 0;
                    } else if (ldl >= 130 && ldl < 160) {
                        this.score += 0;
                    } else if (ldl >= 160 && ldl < 190) {
                        this.score += 2;
                    } else if (ldl >= 190) {
                        this.score += 2;
                    }
                }
            },

            CalcRiscoHdl: function () {

                const hdl = this.inputs.hdl;

                if (this.inputs.genero === "masculino") {
                    if (hdl < 35) {
                        this.score += 2;
                    } else if (hdl >= 35 && hdl < 45) {
                        this.score += 1;
                    } else if (hdl >= 45 && hdl < 50) {
                        this.score += 0;
                    } else if (hdl >= 50 && hdl < 60) {
                        this.score += 0;
                    } else if (hdl >= 60) {
                        this.score += -1;
                    }
                } else if (this.inputs.genero === "feminino") {
                    if (hdl < 35) {
                        this.score += 5;
                    } else if (hdl >= 35 && hdl < 45) {
                        this.score += 2;
                    } else if (hdl >= 45 && hdl < 50) {
                        this.score += 1;
                    } else if (hdl >= 50 && hdl < 60) {
                        this.score += 0;
                    } else if (hdl >= 60) {
                        this.score += -2;
                    }
                }

            },

            CalcRiscoPressao: function () {

                // Faixas de pressão Sistólica
                // 0 < 120
                // 1 120-129
                // 2 130-139
                // 3 140-159
                // 4 >= 160
                // Faixas de pressão Diastólica
                // 0 < 80
                // 1 80-84
                // 2 85-89
                // 3 90-99
                // 4 >= 100
                const pressaoArterial = {
                    masculino: [
                        [0, 0, 1, 2, 3], // < 120
                        [0, 0, 1, 2, 3], // 120-129
                        [1, 1, 1, 2, 3], // 130-139
                        [2, 2, 2, 2, 3], // 140-159
                        [3, 3, 3, 3, 3]  // >= 160
                    ],
                    feminino: [
                        [-3, 0, 0, 2, 3], // < 120
                        [0, 0, 0, 2, 3], // 120-129
                        [0, 0, 0, 2, 3], // 130-139
                        [2, 2, 2, 2, 3], // 140-159
                        [3, 3, 3, 3, 3]  // >= 160
                    ]
                };

                const sistolica = this.inputs.sistolica;
                const diastolica = this.inputs.diastolica;

                let s = 0;
                let d = 0;
                if (sistolica < 120) {
                    s = 0
                } else if (sistolica >= 120 && sistolica < 130) {
                    s = 1
                } else if (sistolica >= 130 && sistolica < 140) {
                    s = 2
                } else if (sistolica >= 140 && sistolica < 160) {
                    s = 3
                } else if (sistolica >= 160) {
                    s = 4
                }
                if (diastolica < 80) {
                    d = 0
                } else if (diastolica >= 80 && diastolica < 85) {
                    d = 1
                } else if (diastolica >= 85 && diastolica < 90) {
                    d = 2
                } else if (diastolica >= 90 && diastolica < 100) {
                    d = 3
                } else if (diastolica >= 100) {
                    d = 4
                }

                if (this.inputs.genero === "masculino") {
                    this.score += pressaoArterial.masculino[s][d];
                } else if (this.inputs.genero === "feminino") {
                    this.score += pressaoArterial.feminino[s][d];
                }
            },

            CalcRiscoDiabetes: function () {
                this.score += this.inputs.diabetes ? 4 : 0;
            },

            CalcRiscoAtividade: function () {
                //Sedentarismo
            },

            CalcRiscoCigarro: function () {
                this.score += this.inputs.cigarro ? 2 : 0;
            },

            showResult: function () {

                function clamp(num, min, max) {
                    return num <= min ? min : +num >= max ? max : +num;
                }

                if (this.inputs.genero === "masculino") {

                    let percentage = {
                        "'-3'": 1,
                        "'-2'": 2,
                        "'-1'": 2,
                        "'0'": 3,
                        "'1'": 4,
                        "'2'": 4,
                        "'3'": 6,
                        "'4'": 7,
                        "'5'": 9,
                        "'6'": 11,
                        "'7'": 14,
                        "'8'": 18,
                        "'9'": 22,
                        "'10'": 27,
                        "'11'": 33,
                        "'12'": 40,
                        "'13'": 47,
                        "'14'": 56
                    };

                    this.chance = percentage["'" + clamp(this.score, -3, 14) + "'"];

                } else if (this.inputs.genero === "feminino") {

                    let percentage = {
                        "'-2'": 1,
                        "'-1'": 2,
                        "'0'": 2,
                        "'1'": 2,
                        "'2'": 3,
                        "'3'": 3,
                        "'4'": 4,
                        "'5'": 5,
                        "'6'": 6,
                        "'7'": 7,
                        "'8'": 8,
                        "'9'": 9,
                        "'10'": 11,
                        "'11'": 13,
                        "'12'": 15,
                        "'13'": 17,
                        "'14'": 20,
                        "'15'": 24,
                        "'16'": 27,
                        "'17'": 32
                    };

                    this.chance = percentage["'" + clamp(this.score, -2, 17) + "'"];
                }
            },


        },

    }
</script>
